import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';

import { LoadingGif, LoadingMessage } from './CommonStyles';

interface ProtectedRouteProps {
	children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
	const { user, isLoading } = useAuth(); // Destructure isLoading
	const location = useLocation();

	// While checking authentication, show a loading indicator
	if (isLoading) {
		return (
			<LoadingMessage>
				<LoadingGif size="large" />
			</LoadingMessage>
		);
	}

	// After loading, if there's no user, redirect to login
	if (!user) {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	// If authenticated, render the requested component
	return children;
};

export default ProtectedRoute;
